import { HostListener, Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { NgbModal, NgbModalRef, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { DashboardPiListBE, DashboardPiMultiSupplierListBE, ApprovalFlowBE, DashboardPartPruBE } from './shared/dashboard.model';
import { DashBoardService } from './dashboard.service';
import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
import { UserHandling } from '../shared/user-handling';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum, ConflictTypeEnum } from '../shared/enums.model';
import { StatusEnum } from '../shared/enums.model';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { InstructionsListBE } from '../../app/packaging-instruction/shared/packaging-instruction.model';
import { ErrorObject } from '../../app/errorhandler/gpiserror-object';
import { ConfirmResult } from '../../app/dialogboxes/shared/confirm.model'
import { AppConfig } from '../config/app.config';
import { UserPruBE } from "../user-management/shared/user-management.model";
import { AttributeListBE } from '../shared/attribute-list.model';
import { NgbDateFRParserFormatter } from '../shared/ngb-date-fr-parser-formatter';
import { forEach } from '@angular/router/src/utils/collection';
import { retry } from 'rxjs/operator/retry';

import { PackageInstructionService } from '../../app/packaging-instruction/packaging-instruction.service';
import { PkgInstrPruRelationBE, PackageInstructionItem, PackageIntructionPart } from '../../app/packaging-instruction/shared/packaging-instruction.model';
import { SupplierService } from '../../app/supplier/supplier.service';
import { SupplierListBE } from '../supplier/shared/supplier.model';
import { InputTextModule } from 'primeng/primeng';
import { isUndefined } from 'util';
import { Server } from 'selenium-webdriver/safari';
import { ChineseChangeValueService } from '../chinese-change-value.service';

var PnL: number = 0;
var CW2: number = 0;

@Component({
    moduleId: module.id,
    selector: 'dashboard',
    templateUrl: 'dashboard.html',
    providers: [DashBoardService, SupplierService, PackageInstructionService,ChineseChangeValueService]
})
export class DashboardComponent implements OnInit, ComponentCanDeactivate {
    user: UserHandling = new UserHandling();

    // data lists
    waitingForApprovalFromSupplierList: DashboardPiListBE[] = [];
    sentToSupplierList: DashboardPiListBE[] = [];
    filteredsentToSupplierList: DashboardPiListBE[] = [];
    approvedBySupplierList: DashboardPiListBE[] = [];
    filteredapprovedBySupplierList: DashboardPiListBE[] = [];
    filteredrejectedBySupplierList: DashboardPiListBE[] = [];
    rejectedBySupplierList: DashboardPiListBE[] = [];
    sentToMultiBySupplierList: DashboardPiMultiSupplierListBE[] = [];
    pruPreliminariesList: InstructionsListBE[] = [];
    pruValidationList: DashboardPiListBE[] = [];
    pruList: AttributeListBE[] = [];
    userList: AttributeListBE[];
    partPruUpdateList: DashboardPartPruBE[];

    // Spinners
    showWaitingForApprovalSpinner: boolean = false;
    showSentToSupplierListSpinner: boolean = false;
    showApprovedBySupplierListSpinner: boolean = false;
    showRejectedBySupplierListSpinner: boolean = false;
    showPruPreliminariesListSpinner: boolean = false;
    showSentToMultiBySupplierListSpinner: boolean = false;
    showPruValidationListSpinner: boolean = false;
    showPartPruListSpinner: boolean = false;

    // Date control
    desiredStartDate: NgbDateStruct;
    dateFormatter: NgbDateFRParserFormatter = new NgbDateFRParserFormatter();

    // Dialog boxes
    currentDlg: NgbModalRef;
    currentId: number;
    packType:number;
    currentSupplierId: number;
    errorObj: ErrorObject = null;
    pendingAction: any = null;
    comments: string = "";
    approveRejectText: string = "";
    approveRejectTextIcon: string = "";
    supplierSuggestedDate: string = "";
    acceptSupplierDateSuggestion: string = "true";
    piName: string = "";
    packagingType: number;
    selectedInstructionId: number;
    instructionType: number;

    // Toggle select all check boxes
    selectAllRejectItems: boolean = false;
    selectAllActivateItems: boolean = false;
    selectAllSentToMultiItems: boolean = false;

    // confirm dialog
    @ViewChild('cDlg') cdlg: ElementRef;
    dialogAction: string;
    dialogAppliesTo: string = "";
    dialogAppliesToId: number = -1;
    dialogAppliesToInstructionType: number = -1;
    confirmDlgText: string = "";

    // misc
    activateFromList: string = "";
    isContactsInfoExpired: boolean = null;
    url:string=null;

    //paging
    isapprovallist: boolean = null;
    issenttosupplierlist: boolean = null;
    isrejectlist: boolean = null;

    //LongTerm
    @ViewChild('conflictPruDlgDashboard') conflictPruDlg: ElementRef;
    conflictResponseObj: Array<PkgInstrPruRelationBE>;
    activeConflictItemId: number;
    itemNoToActivate: number = 0;
    public conflictEnums = ConflictTypeEnum;
    currentConflictDlg: NgbModalRef;
    instruction: PackageInstructionItem = undefined;

    selectedSupplierName: string = "";
    extendedsuppliername: string = "";
    selectedSupplierId: number = 0;
    suppliercontactlist: SupplierListBE[];

    constructor(private dashBoardService: DashBoardService,
        private errHandler: ErrorHandlerService,
        private modalService: NgbModal,
        private config: AppConfig, private router: Router,
        public supplierService: SupplierService,
        private packInstrService: PackageInstructionService
    ) {
        errHandler.errorEvent.subscribe((err: ErrorObject) => this.onError(err));
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        return true;
    }

    ngOnInit() {
        while (this.user.UserId == null)
            this.wait()
        if (this.user.SupplierNumber != null && this.user.SupplierNumber !== 'undefined') {
            this.getSupplierBySupplierNo(this.user.SupplierNumber, this.user.ExtendedSupplierNumber);
        }

        if (this.user.IsPackagingEngineer) {
            this.getPruPreliminaries();
            this.getWaitingForApproval();
            this.getSupplierApproved();
            this.getSupplierRejected();
            this.getSentToMultipleSuppliers();
            this.getAdminSentToSupplier();
            this.getPruList();
            this.getPartPruUpdates();
            return;
        }

        if (this.user.IsPackagingAdmin) {

            this.getPruPreliminaries();
            this.getWaitingForApproval();
            this.getSupplierApproved();
            this.getSupplierRejected();
            this.getSentToMultipleSuppliers();
            this.getAdminSentToSupplier();
            this.getPruList();
            this.getPartPruUpdates();
            return;
        }

        if (this.user.IsPartSupplierUser) {
            this.getSupplierInfoExpiryDate();
            this.getSentToSupplier();
            this.getSupplierApproved();
            this.getSupplierRejected();
            return;
        }

        if (this.user.IsTestPackager) {

            this.getPruPreliminaries();
            this.getWaitingForApproval();
            this.getPartPruUpdates();
            return;
        }

        if (this.user.IsDeveloper) {
            //this.getPruValidations();       // Validations on Packaging instructions by PRU (showing top 25)
            this.getPruPreliminaries();     // Preliminary Packaging instructions by PRU
            this.getWaitingForApproval();   // Packaging instructions waiting for supplier approval
            this.getSupplierApproved();     // Approved package instructions sent to single supplier
            this.getSupplierRejected();     // Rejected package instructions sent to single supplier
            this.getSentToMultipleSuppliers();  // Rejected/approved package instructions sent to multiple suppliers
            this.getAdminSentToSupplier();
            this.getPruList();
            this.getPartPruUpdates();
            return;
        }
    }


    // ------------------------------------
    // Fetch data
    // ------------------------------------
    getPruValidations() {
        this.showPruValidationListSpinner = true;
        this.rejectedBySupplierList = [];
        this.errorObj = null;

        this.dashBoardService.getListForValidationInfo(this.user.UserId)//, "")
            .subscribe(returnObject => this.getListForValidationInfoResult(returnObject));

    }

    getPruPreliminaries() {
        this.showPruPreliminariesListSpinner = true;
        this.rejectedBySupplierList = [];
        this.errorObj = null;

        this.dashBoardService.getPrelPruInstructionsList(this.user.UserId)//,"")
            .subscribe(returnObject => this.getPruPreliminariesResult(returnObject));
    }

    getPruPreliminariesResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.getPruPreliminariesResult', returnObject.ErrorType);
        else
            this.pruPreliminariesList = <InstructionsListBE[]>returnObject.DataList;

        this.showPruPreliminariesListSpinner = false;
    }

    getListForValidationInfoResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.getListForValidationInfoResult', returnObject.ErrorType);
        else
            this.pruValidationList = <DashboardPiListBE[]>returnObject.DataList;

        this.showPruValidationListSpinner = false;
    }


    getWaitingForApproval() {
        this.showWaitingForApprovalSpinner = true;
        this.sentToSupplierList = [];
        this.errorObj = null;

        this.dashBoardService.getWaitingForApprovalList(this.user.UserId)//,"")
            .subscribe(returnObject => this.getWaitingForApprovalResult(returnObject));
    }

    getWaitingForApprovalResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.getWaitingForApprovalResult', returnObject.ErrorType);
        else
            this.waitingForApprovalFromSupplierList = <DashboardPiListBE[]>returnObject.DataList;

        this.showWaitingForApprovalSpinner = false;
    }

    getSentToSupplier() {
        this.showSentToSupplierListSpinner = true;
        this.sentToSupplierList = [];
        this.errorObj = null;

        this.dashBoardService.getSentToSupplierList(this.user.SupplierNumber, this.user.ExtendedSupplierNumber)//,"")
            .subscribe(returnObject => this.getSentToSupplierResult(returnObject));
    }

    getSentToSupplierResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.getSentToSupplierResult', returnObject.ErrorType);
        else
        {
           this.sentToSupplierList = <DashboardPiListBE[]>returnObject.DataList;
           if(this.sentToSupplierList.length > 0 && this.sentToSupplierList.length > 25)
            {
               this.issenttosupplierlist = true;
               this.filteredsentToSupplierList = <DashboardPiListBE[]>returnObject.DataList;
               this.sentToSupplierList = this.sentToSupplierList.slice(0, 25);
            }
        }
        this.showSentToSupplierListSpinner = false;
    }

    getAdminSentToSupplier() {
        this.showSentToSupplierListSpinner = true;
        this.sentToSupplierList = [];
        this.errorObj = null;

        this.dashBoardService.getAdminSentToSupplierList(this.user.UserId, this.user.IsPackagingEngineer)
            .subscribe(returnObject => this.getAdminSentToSupplierResult(returnObject));
    }

    getAdminSentToSupplierResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.getAdminSentToSupplierResult', returnObject.ErrorType);
        else
        {
           this.sentToSupplierList = <DashboardPiListBE[]>returnObject.DataList;
           if(this.sentToSupplierList.length > 0 && this.sentToSupplierList.length > 25)
            {
               this.issenttosupplierlist = true;
               this.filteredsentToSupplierList = <DashboardPiListBE[]>returnObject.DataList;
               this.sentToSupplierList = this.sentToSupplierList.slice(0, 25);
            }
        }


        this.showSentToSupplierListSpinner = false;
    }

    SentToSupplierItems()
    {
       this.sentToSupplierList = this.filteredsentToSupplierList;
       this.issenttosupplierlist = false;
    }

    getSupplierApproved() {
        this.showApprovedBySupplierListSpinner = true;
        this.approvedBySupplierList = [];
        this.errorObj = null;

        this.dashBoardService.getListFor(StatusEnum.ApprovedBySupplier, this.user.UserId, this.user.SupplierNumber, this.user.ExtendedSupplierNumber)//,"")
            .subscribe(returnObject => this.getSupplierApprovedResult(returnObject));
    }

    getSupplierApprovedResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.getSupplierApprovedResult', returnObject.ErrorType);
        else
        {
            this.approvedBySupplierList = <DashboardPiListBE[]>returnObject.DataList;
            if(this.approvedBySupplierList.length > 0 && this.approvedBySupplierList.length > 25)
            {
               this.isapprovallist = true;
               this.filteredapprovedBySupplierList = <DashboardPiListBE[]>returnObject.DataList;
               this.approvedBySupplierList = this.approvedBySupplierList.slice(0, 25);
            }
        }
        this.showApprovedBySupplierListSpinner = false;
    }

    ApprovedItems()
    {
       this.approvedBySupplierList = this.filteredapprovedBySupplierList;
       this.isapprovallist = false;
    }

    getSupplierRejected() {
        this.showRejectedBySupplierListSpinner = true;
        this.rejectedBySupplierList = [];
        this.errorObj = null;

        this.dashBoardService.getListFor(StatusEnum.RejectedBySupplier, this.user.UserId, this.user.SupplierNumber, this.user.ExtendedSupplierNumber)//,"")
            .subscribe(returnObject => this.getSupplierRejectedResult(returnObject));
    }

    getSupplierRejectedResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.getSupplierRejectedResult', returnObject.ErrorType);
        else
        {
            this.rejectedBySupplierList = <DashboardPiListBE[]>returnObject.DataList;
            if(this.rejectedBySupplierList.length > 0 && this.rejectedBySupplierList.length > 25)
            {
               this.isrejectlist = true;
               this.filteredrejectedBySupplierList = <DashboardPiListBE[]>returnObject.DataList;
               this.rejectedBySupplierList = this.rejectedBySupplierList.slice(0, 25);
            }
        }
        this.showRejectedBySupplierListSpinner = false;
    }

    RejectedItems()
    {
       this.rejectedBySupplierList = this.filteredrejectedBySupplierList;
       this.isrejectlist = false;
    }

    getSentToMultipleSuppliers() {
        this.showSentToMultiBySupplierListSpinner = true;
        this.sentToMultiBySupplierList = [];
        this.sentToMultiBySupplierList = [];
        this.errorObj = null;

        this.dashBoardService.getSentToMultipleList(this.user.UserId)//,"")
            .subscribe(returnObject => this.getSentToMultipleSuppliersResult(returnObject));
    }

    getSentToMultipleSuppliersResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.getSentToMultipleSuppliersResult', returnObject.ErrorType);
        else {
            let tempDta: DashboardPiListBE[] = <DashboardPiListBE[]>returnObject.DataList;
            let curIndex = this.sentToMultiBySupplierList.length - 1;

            let i: number = 0;
            while (i < tempDta.length) {
                let piId = tempDta[i].InstructionId;
                let newMultiItem = new DashboardPiMultiSupplierListBE();
                let foundSentToMultiItem: boolean = false;

                // assume that list is sorted by instruction id and then supplier
                while (piId == tempDta[i].InstructionId) {
                    if (tempDta[i].ToStatusId == StatusEnum.ApprovedBySupplier
                        || tempDta[i].ToStatusId == StatusEnum.RejectedBySupplier)
                        foundSentToMultiItem = true;

                    newMultiItem.PartNo = tempDta[i].PartNo;
                    newMultiItem.PartDescription = tempDta[i].PartDescription;
                    newMultiItem.InstructionId = tempDta[i].InstructionId;
                    newMultiItem.PackagingType = tempDta[i].PackagingType;
                    newMultiItem.IssuerUserName = tempDta[i].IssuerUserName;
                    newMultiItem.SupplierResponses.push(tempDta[i]);
                    i++;

                    if (i >= tempDta.length)
                        break;
                }
                // only add (and show in gui) if one or more of the suppliers approved or rejected
                if (foundSentToMultiItem)
                    this.sentToMultiBySupplierList.push(newMultiItem);
            }
        }
        this.showSentToMultiBySupplierListSpinner = false;
    }


    getSupplierInfoExpiryDate() {
        this.errorObj = null;
        if (!this.isSupplierWithNoSuppNo()) {
            this.dashBoardService.getSupplierInfoExpiryDate(this.user.SupplierNumber, this.user.ExtendedSupplierNumber)
                .subscribe(returnObject => this.getSupplierInfoExpiryDateResult(returnObject));
        }
    }

    getSupplierInfoExpiryDateResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.getSentToSupplierResult', returnObject.ErrorType);
        else {
            if (returnObject.DataList[0] != null) {
                this.isContactsInfoExpired = this.supplierService.isSupplierInfoValid(returnObject.DataList[0])
            }
            else
                this.isContactsInfoExpired = true;
        }
    }

    getPartPruUpdates() {
        this.showPruValidationListSpinner = true;
        this.partPruUpdateList = [];
        this.errorObj = null;
        this.dashBoardService.GetPartPruUpdates()
            .subscribe(returnObject => this.getPartPruUpdatesResult(returnObject));
    }

    getPartPruUpdatesResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.getPartPruUpdatesResult', returnObject.ErrorType);
        else
            this.partPruUpdateList = <DashboardPartPruBE[]>returnObject.DataList;
        this.showPartPruListSpinner = false;
    }

    getPruList() {
        this.pruList = [];
        this.dashBoardService.GetPruList()
            .subscribe(returnObject => this.getPruListResult(returnObject));
    }

    getPruListResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.getPartPruUpdatesResult', returnObject.ErrorType);
        else {
            this.pruList = <AttributeListBE[]>returnObject.DataList;
            this.pruList = this.pruList.filter(item => item.Description.toLowerCase().includes('missing') == false);
        }
    }

    getSelectedPru(pruId: number) {
        this.showPartPruListSpinner = true;
        if (pruId == -1)
            this.dashBoardService.GetPartPruUpdates()
                .subscribe(returnObject => this.getPartPruUpdatesResult(returnObject));
        else
            this.dashBoardService.getSelectedPruChanges(pruId)
                .subscribe(returnObject => this.getPartPruUpdatesResult(returnObject));
    }

    setDashboardEntires() {
        this.getPruPreliminaries();
        //this.getPruValidations();
        this.getWaitingForApproval();
        this.getSupplierApproved();
        this.getSupplierRejected();
        this.getSentToSupplier();
    }

    // ------------------------------------
    // Update db data
    // ------------------------------------
    updateFlowStatus(id: number, supplierId: number, toStatus: StatusEnum, list: DashboardPiListBE[], instructionType: number) {
        let itm = list.find(x => x.Id == id);
        let piId: number = itm.InstructionId;
        let fromStatus: StatusEnum = itm.ToStatusId;
        let sDate: string = "";

        if ((toStatus === StatusEnum.Active && this.acceptSupplierDateSuggestion == "false")
            || toStatus === StatusEnum.ApprovedBySupplier) {
            sDate = this.getDesiredStartDateString();
        }
        else if ((Number(toStatus) == Number(StatusEnum.Active) && this.acceptSupplierDateSuggestion == "true")
            || Number(toStatus) == Number(StatusEnum.RejectedBySupplier)
            || Number(toStatus) == Number(StatusEnum.Scrapped)
            || Number(toStatus) == Number(StatusEnum.Preliminary)) {
            sDate = this.getItemStartDateString(itm.StartDate);
        }

        let updData: ApprovalFlowBE = new ApprovalFlowBE();

        updData.FromStatusId = fromStatus;
        updData.ToStatusId = toStatus;
        updData.InstructionId = piId;
        updData.Message = this.comments;
        updData.StartDate = sDate;
        updData.SupplierId = supplierId;
        updData.UserId = this.user.UserId;
        updData.ApproverOrRejectorSupplierId = this.selectedSupplierId;
        updData.InstructionType = instructionType;

        this.dashBoardService.updateFlowStatus(updData)
            .subscribe(returnObject => this.updateFlowStatusResult(returnObject, id, list, piId, toStatus));
    }

    updateFlowStatusResult(returnObject: IReturnObject, id: number, list: DashboardPiListBE[], instrID: number, toStatusId: StatusEnum) {
        const prelClick = (!this.user.IsPartSupplierUser && toStatusId === 4);
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.updateFlowStatusResult', returnObject.ErrorType);
        else {
            let itmIndex = list.findIndex(x => x.Id == id);
            list.splice(itmIndex, 1);
            this.info("Successful operation.");

            // if (this.approveRejectText == 'Approve')
            //     this.info("Approved successfully");
            // else if (this.approveRejectText == 'Reject')
            //     this.info("Rejected successfully");
            // else if (this.activateFromList == "approved" ||
            //     this.activateFromList == "senttomultiple" ||
            //     this.activateFromList == "rejected")
            //     this.info("Activated successfully");

            this.activateAllCheckedItems();
        }

        this.hideLoadingAnimations();

        /** Route to pi if reverting pi from rejected (statusId == 4) and not partsupplier */
        if (prelClick && instrID !== null) {
            alert("Instruction is rejected by supplier");
            this.router.navigateByUrl(this.url + instrID);
        }

        this.url="";
    }

    hideLoadingAnimations() {
        this.showWaitingForApprovalSpinner = false;
        this.showSentToSupplierListSpinner = false;
        this.showApprovedBySupplierListSpinner = false;
        this.showRejectedBySupplierListSpinner = false;
        this.showPruPreliminariesListSpinner = false;

        this.showSentToMultiBySupplierListSpinner = false;

    }

    updateSentToMultipleFlowStatus(instructionId: number, toStatus: StatusEnum, instructionType: number) {
        let sDate: string = "";

        if (toStatus === StatusEnum.Active && this.acceptSupplierDateSuggestion == "false") {
            sDate = this.getDesiredStartDateString();
        }

        let updData: ApprovalFlowBE = new ApprovalFlowBE();
        updData.ToStatusId = toStatus;
        updData.InstructionId = instructionId;
        updData.Message = this.comments;
        updData.StartDate = sDate;
        updData.UserId = this.user.UserId;
        updData.InstructionType = instructionType;

        this.dashBoardService.updateSentToMultipleFlowStatus(updData)
            .subscribe(returnObject => this.updateSentToMultipleFlowStatusResult(returnObject, instructionId));
    }

    updateSentToMultipleFlowStatusResult(returnObject: IReturnObject, instructionId: number) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.updateFlowStatusResult', returnObject.ErrorType);
        else {
            let itmIndex = this.sentToMultiBySupplierList.findIndex(x => x.InstructionId == instructionId);
            this.sentToMultiBySupplierList.splice(itmIndex, 1);
            this.info("Successfull operation.");
            this.activateAllCheckedItems();
        }
        this.showSentToMultiBySupplierListSpinner = false;
    }


    // ------------------------------------
    // Actions
    // ------------------------------------
    deleteItem(id: number, supplierId: number) {
        this.showRejectedBySupplierListSpinner = true;
        this.updateFlowStatus(id, supplierId, StatusEnum.Scrapped, this.rejectedBySupplierList,-1);
    }

    makeItemPreliminary(id: number, supplierId: number) {
        this.showRejectedBySupplierListSpinner = true;
        this.updateFlowStatus(id, supplierId, StatusEnum.Preliminary, this.rejectedBySupplierList, -1);
    }

    activateAllCheckedItems() {
        this.itemNoToActivate = 0;
        this.performActivateAllCheckedItems();
    }

    performActivateAllCheckedItems() {

        // if (this.activateFromList == "approved") {
        //     this.showApprovedBySupplierListSpinner = true;
        //     for (var i = 0; i < this.approvedBySupplierList.length; i++) {
        //         if (this.approvedBySupplierList[i].SuppApprovedSelected)
        //             this.updateFlowStatus(this.approvedBySupplierList[i].Id, this.approvedBySupplierList[i].SupplierId, StatusEnum.Active, this.approvedBySupplierList);
        //     }
        // }
        if (this.activateFromList == "approved") {
            this.showApprovedBySupplierListSpinner = true;
            if (this.approvedBySupplierList.length > 0
                && this.itemNoToActivate < this.approvedBySupplierList.length) {
                if (this.approvedBySupplierList[this.itemNoToActivate].SuppApprovedSelected) {
                    this.loadInstruction(this.approvedBySupplierList[this.itemNoToActivate].InstructionId);
                }
                else {
                    this.itemNoToActivate++;
                    this.performActivateAllCheckedItems();
                }
            }
        }

        // else if (this.activateFromList == "rejected") {
        //     this.showRejectedBySupplierListSpinner = true;
        //     for (var i = 0; i < this.rejectedBySupplierList.length; i++) {
        //         if (this.rejectedBySupplierList[i].RejectSelected)
        //             this.updateFlowStatus(this.rejectedBySupplierList[i].Id, this.rejectedBySupplierList[i].SupplierId, StatusEnum.Active, this.rejectedBySupplierList);
        //     }
        // }
        else if (this.activateFromList == "rejected") {
            this.showRejectedBySupplierListSpinner = true;
            if (this.rejectedBySupplierList.length > 0
                && this.itemNoToActivate < this.rejectedBySupplierList.length) {
                if (this.rejectedBySupplierList[this.itemNoToActivate].RejectSelected)
                    this.loadInstruction(this.rejectedBySupplierList[this.itemNoToActivate].InstructionId);
                else {
                    this.itemNoToActivate++;
                    this.performActivateAllCheckedItems();
                }
            }

        }


        // else if (this.activateFromList == "senttomultiple") {
        //     this.showSentToMultiBySupplierListSpinner = true;
        //     for (var i = 0; i < this.sentToMultiBySupplierList.length; i++) {
        //         if (this.sentToMultiBySupplierList[i].SentToMultiSelected)
        //             this.updateSentToMultipleFlowStatus(this.sentToMultiBySupplierList[i].InstructionId, StatusEnum.Active);
        //     }
        // }
        else if (this.activateFromList == "senttomultiple") {
            this.showSentToMultiBySupplierListSpinner = true;
            if (this.sentToMultiBySupplierList.length > 0
                && this.itemNoToActivate < this.sentToMultiBySupplierList.length) {
                if (this.sentToMultiBySupplierList[this.itemNoToActivate].SentToMultiSelected)
                    this.loadInstruction(this.sentToMultiBySupplierList[this.itemNoToActivate].InstructionId);
                else {
                    this.itemNoToActivate++;
                    this.performActivateAllCheckedItems();
                }
            }
        }
        this.currentDlg.close();
    }

    doAllRejectedCheckedItems(toStatus: StatusEnum) {
        this.showRejectedBySupplierListSpinner = true;
        for (var i = 0; i < this.rejectedBySupplierList.length; i++) {
            if (this.rejectedBySupplierList[i].RejectSelected)
                this.updateFlowStatus(this.rejectedBySupplierList[i].Id, this.rejectedBySupplierList[i].SupplierId, toStatus, this.rejectedBySupplierList, -1);
        }
        this.closeDlg();
    }

    deleteSentToMultiItem(instructionId: number) {
        this.showSentToMultiBySupplierListSpinner = true;
        this.updateSentToMultipleFlowStatus(instructionId, StatusEnum.Scrapped, -1);
    }

    makeSentToMultiItemPreliminary(instructionId: number) {
        this.showSentToMultiBySupplierListSpinner = true;
        this.updateSentToMultipleFlowStatus(instructionId, StatusEnum.Preliminary,-1);
    }

    doAllSentToMultiCheckedItems(toStatus: StatusEnum) {
        this.showSentToMultiBySupplierListSpinner = true;
        for (var i = 0; i < this.sentToMultiBySupplierList.length; i++) {
            if (this.sentToMultiBySupplierList[i].SentToMultiSelected)
                this.updateSentToMultipleFlowStatus(this.sentToMultiBySupplierList[i].InstructionId, toStatus,-1);
        }
        this.closeDlg();
    }

    approveReject(currentId: number, currentSupplierId: number) {
        this.showSentToSupplierListSpinner = true;
        if (this.approveRejectText == "Approve")
            this.updateFlowStatus(currentId, currentSupplierId, StatusEnum.ApprovedBySupplier, this.sentToSupplierList, -1);
        if (this.approveRejectText == "Reject")
            this.updateFlowStatus(currentId, currentSupplierId, StatusEnum.RejectedBySupplier, this.sentToSupplierList, -1);
        this.closeDlg();
    }

    isapproveRejectDisabled() {
        if (this.approveRejectText == "Reject") {
            if (this.comments == "")
                return true;
        }
    }

    // ------------------------------------
    // Pending action
    // ------------------------------------
    deleteItemId: any = (id: number) => {
        let supplierId: number = this.rejectedBySupplierList.find(x => x.Id == id).SupplierId;
        this.pendingAction = null;
        this.deleteItem(id, supplierId);
    }

    makeItemIdPreliminary: any = (instructionId: number) => {
        let supplierId: number = this.rejectedBySupplierList.find(x => x.InstructionId == instructionId).SupplierId;
        this.pendingAction = null;
        let id = this.rejectedBySupplierList.find(x => x.InstructionId == instructionId).Id;
        this.makeItemPreliminary(id, supplierId);
    }

    deleteAll: any = () => {
        this.pendingAction = null;
        this.doAllRejectedCheckedItems(StatusEnum.Scrapped);
    }

    preliminaryAll: any = () => {
        this.pendingAction = null;
        this.doAllRejectedCheckedItems(StatusEnum.Preliminary);
    }

    deleteSentToMultiItemId: any = (instructionId: number) => {
        this.pendingAction = null;
        this.deleteSentToMultiItem(instructionId);
    }

    makeSentToMultiItemIdPreliminary: any = (instructionId: number) => {
        this.pendingAction = null;
        this.makeSentToMultiItemPreliminary(instructionId);
    }

    deleteSentToMultiAll: any = () => {
        this.pendingAction = null;
        this.doAllSentToMultiCheckedItems(StatusEnum.Scrapped);
    }

    preliminarySentToMultiAll: any = () => {
        this.pendingAction = null;
        this.doAllSentToMultiCheckedItems(StatusEnum.Preliminary);
    }


    // ------------------------------------
    // Dialog boxes sent to single supplier
    // ------------------------------------
    openApproveItem(item: DashboardPiListBE, modal: any) {
        this.comments = "";
        this.approveRejectText = "Approve";
        this.approveRejectTextIcon = "fa-thumbs-o-up";
        this.setStartDateCalenderValue(item);
        this.currentId = item.Id;
        this.currentSupplierId = item.SupplierId;
        this.errHandler.emitErrorObject(null);
        this.currentDlg = this.modalService.open(modal, { size: 'sm' });
    }

    openActivateItem(item: DashboardPiListBE, modal: any, useList: string) {
        this.comments = "";
        this.activateFromList = useList;
        item.SuppApprovedSelected = useList == "approved";
        item.RejectSelected = useList == "rejected";
        this.currentId = item.Id;
        this.currentSupplierId = item.SupplierId;
        this.setStartDateCalenderValue(item);
        this.supplierSuggestedDate = "(" + this.getDesiredStartDateString() + ")";
        this.errHandler.emitErrorObject(null);
        this.currentDlg = this.modalService.open(modal, { size: 'sm' });
    }

    openActivateAll(modal: any, useList: string) {
        this.comments = "";
        this.activateFromList = useList;
        this.errHandler.emitErrorObject(null);
        this.setStartDateCalenderValue(null);
        this.supplierSuggestedDate = "";
        this.currentDlg = this.modalService.open(modal, { size: 'sm' });
    }

    openRejectItem(item: DashboardPiListBE, modal: any) {
        this.comments = "";
        this.approveRejectText = "Reject";
        this.approveRejectTextIcon = "fa-thumbs-o-down";
        this.currentId = item.Id;
        this.packType=item.PackagingType;//to differentiate between instruction types
        this.redirectTo(this.packType);
        console.log("pack"+this.packType);
        this.currentSupplierId = item.SupplierId;
        this.errHandler.emitErrorObject(null);
        this.currentDlg = this.modalService.open(modal, { size: 'sm' });
    }

    openMessage(message: string, modal: any) {
        this.comments = message;
        this.currentDlg = this.modalService.open(modal, { size: 'sm' });
    }

    openConfirmDlg(itemId: number, action: string,type:number) {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = action;
        if(type==1){ this.dialogAppliesTo = 'Package Instruction';}
        else{ this.dialogAppliesTo = 'Sequence Instruction';}
        this.dialogAppliesToId = itemId;
        this.currentDlg = this.modalService.open(this.cdlg, { size: 'sm' });
    }

    openConfirmDeleteDlg(itemId: number) {

        this.pendingAction = this.deleteItemId;
        this.openConfirmDlg(itemId, "delete",-1);
    }

    openConfirmDeleteAllDlg() {

        this.pendingAction = this.deleteAll;
        this.openConfirmDlg(-1, "deleteall",-1);
    }

    openConfirmMakePreliminaryDlg(itemId: number,type:number) {
        this.redirectTo(type);  //to decide whether instruction should be redirected to sequence/packaging instruction
        this.pendingAction = this.makeItemIdPreliminary;
        this.openConfirmDlg(itemId, "makepreliminary",type);
    }

    openConfirmPreliminaryAllDlg() {
        this.pendingAction = this.preliminaryAll;
        this.openConfirmDlg(-1, "makepreliminaryall",-1);
    }


    // ------------------------------------
    // Dialog boxes Approve/Reject multiple suppliers
    // ------------------------------------
    openConfirmDeleteAllSentToMultiDlg(modal: any) {
        this.pendingAction = this.deleteSentToMultiAll;
        this.openConfirmDlg(-1, "deleteallsenttomulti",-1 );
    }

    openConfirmPreliminaryAllSentToMultiDlg() {
        this.pendingAction = this.preliminarySentToMultiAll;
        this.openConfirmDlg(-1, "makepreliminaryallsenttomulti",-1);
    }

    openActivateAllSentToMulti(modal: any, instructionType: number) {
        this.comments = "";
        this.activateFromList = "senttomultiple";
        this.errHandler.emitErrorObject(null);
        this.setStartDateCalenderValue(null);
        this.supplierSuggestedDate = "";
        this.currentDlg = this.modalService.open(modal, { size: 'sm' });
    }

    openConfirmDeleteSentToMultiDlg(instructionId: number) {
        this.pendingAction = this.deleteSentToMultiItemId;
        this.openConfirmDlg(instructionId, "deletesenttomulti",-1);
    }

    openConfirmMakePreliminarySentToMultiDlg(instructionId: number,type:number) {
        this.redirectTo(type);
        this.pendingAction = this.makeSentToMultiItemIdPreliminary;
        this.openConfirmDlg(instructionId, "makepreliminarysenttomulti",type);
    }

    openActivateSentToMultiItem(item: DashboardPiMultiSupplierListBE, modal: any) {
        this.comments = "";
        this.acceptSupplierDateSuggestion = "false";
        this.activateFromList = "senttomultiple";
        item.SentToMultiSelected = true;
        this.currentId = item.InstructionId;
        this.setStartDateCalenderValue(item.SupplierResponses[0]);
        this.supplierSuggestedDate = "(" + this.getDesiredStartDateString() + ")";
        this.errHandler.emitErrorObject(null);
        this.currentDlg = this.modalService.open(modal, { size: 'sm' });
    }


    // ------------------------------------
    // Dialog boxes other
    // ------------------------------------
    openViewPiDlg(modal: any, item: DashboardPiListBE) {
        this.selectedInstructionId = item.InstructionId;
        if(item.PIName != null || !isUndefined(item.PIName))
        {
          this.piName = item.PIName;
        }
        else{
          this.piName = item.PartDescription;
        }

        this.packagingType = item.PackagingType;
        console.log(this.packagingType)
        this.currentDlg = this.modalService.open(modal, { size: 'lg' });
    }
    redirectTo(type:number){
        /*console.log(uri);
        this.router.navigateByUrl('/', {skipLocationChange: false}).then(()=>
        this.router.navigate([this.router.navigate([uri])]));*/
        if(type==1)
        {
            this.url='/packaging_instruction/';
        }
        else if(type==2)
        {
            this.url='/sequence_instruction/';
        }
        else{
          alert('type'+type);
        }
        console.log(this.url);
     }
     isPackaging():string
     {
        var pathArray=window.location.href.split('/');
        var lastElement=pathArray[pathArray.length-1];
        console.log(lastElement);
        return lastElement;
     }

    // ------------------------------------
    // Confirm dialog response
    // ------------------------------------
    onConfirmDlgNotify(command: ConfirmResult): void {
        if (command.Action == "delete") {
            this.pendingAction(command.Id);
        }
        else if (command.Action == "deletesenttomulti") {
            this.pendingAction(command.Id);
        }
        else if (command.Action == "deleteallsenttomulti") {
            this.pendingAction();
        }
        else if (command.Action == "deleteall") {
            this.pendingAction();
        }
        else if (command.Action == "makepreliminary") {
            this.pendingAction(command.Id,);
            alert("Instruction is now preliminary");
            //this.redirectTo(this.url + command.Id);
            this.router.navigateByUrl(this.url+command.Id);
        }
        else if (command.Action == "makepreliminaryall") {
            this.pendingAction();
        }
        else if (command.Action == "makepreliminarysenttomulti") {
            this.pendingAction(command.Id);
            alert("Instruction is now preliminary");
            this.router.navigateByUrl(this.url+command.Id);
        }
        else if (command.Action == "makepreliminaryallsenttomulti") {
            this.pendingAction();
        }

        this.closeDlg();
    }


    // ------------------------------------
    // Misc
    // ------------------------------------
    closeDlg() {
        this.comments = "";
        this.desiredStartDate = null;
        this.supplierSuggestedDate = "";
        this.currentDlg.close();
    }

    onError(error: ErrorObject) {
        this.errorObj = this.errHandler.getError();
    }

    wait() {

    }


    // ------------------------------------
    // Date handling
    // ------------------------------------
    getDesiredStartDateString(): string {
        if (this.desiredStartDate != null)
            return this.dateFormatter.format(this.desiredStartDate)
        else {
            let date = new Date(Date.now());
            date.setFullYear(2100);
            return this.dateFormatter.toDateString(date);
        }
    }

    getItemStartDateString(itemDate: Date): string {
        if (itemDate == null)
            return "";
        return this.dateFormatter.toDateString(itemDate);
    }

    setStartDateCalenderValue(item: DashboardPiListBE) {
        let date;
        date = (item != null && item.StartDate != null)
            ? new Date(item.StartDate).toISOString()
            : new Date(Date.now()).toISOString();

        this.desiredStartDate = this.dateFormatter.parse(date);
    }

    getSuggestedStartDateString(suggStartDate: Date): string {
        if (suggStartDate == null)
            return "not set";
        else {
            return this.dateFormatter.toDateString(suggStartDate);

        }
    }


    // ------------------------------------
    // GUI manipulation
    // ------------------------------------
    toggleAllActivateCB() {
        for (var i = 0; i < this.approvedBySupplierList.length; i++) {
            this.approvedBySupplierList[i].SuppApprovedSelected = this.selectAllActivateItems;
        }
    }

    toggleAllRejectedCB() {
        for (var i = 0; i < this.rejectedBySupplierList.length; i++) {
            this.rejectedBySupplierList[i].RejectSelected = this.selectAllRejectItems;
        }
    }

    toggleAllSentToMultiCB() {
        for (var i = 0; i < this.sentToMultiBySupplierList.length; i++) {
            this.sentToMultiBySupplierList[i].SentToMultiSelected = this.selectAllSentToMultiItems;
        }
    }

    setActivateToggleAll() {
        this.selectAllActivateItems = this.approvedBySupplierList.findIndex(x => x.SuppApprovedSelected == true) != -1;
    }

    setRejectedToggleAll() {
        this.selectAllRejectItems = this.rejectedBySupplierList.findIndex(x => x.RejectSelected == true) != -1;
    }

    setSentToMultiToggleAll() {
        this.selectAllSentToMultiItems = this.sentToMultiBySupplierList.findIndex(x => x.SentToMultiSelected == true) != -1;
    }

    isAllRejectedDisabled(): boolean {
        return this.rejectedBySupplierList.findIndex(x => x.RejectSelected == true) == -1;
    }

    isAllSentToMultiDisabled(): boolean {
        return this.sentToMultiBySupplierList.findIndex(x => x.SentToMultiSelected == true) == -1;
    }

    isAllSupplierApprovedDisabled(): boolean {
        return this.approvedBySupplierList.findIndex(x => x.SuppApprovedSelected == true) == -1;
    }


    // ------------------------------------
    // Access control
    // ------------------------------------
    isValidationListVisible(): boolean {
        while (this.user.UserId == null)
            this.wait()
        let isVisible: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsTestPackager
                || this.user.IsDeveloper);

        return isVisible;
    }

    isPruPreliminariesListVisible(): boolean {
        while (this.user.UserId == null)
            this.wait()
        let isVisible: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsTestPackager
                || this.user.IsDeveloper);

        return isVisible;
    }

    isSupplierApproveListVisible(): boolean {
        while (this.user.UserId == null)
            this.wait()
        let isVisible: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPartSupplierUser
                || this.user.IsDeveloper
                || this.user.IsPackagingEngineer);

        return isVisible;
    }

    isPruPartUpdatesListVisible(): boolean {
        while (this.user.UserId == null)
            this.wait()
        let isVisible: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsDeveloper);

        return isVisible;
    }

    isApproveRejectedListsVisible(): boolean {
        while (this.user.UserId == null)
            this.wait()
        let isVisible: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                // || this.user.IsPartSupplierUser
                || this.user.IsDeveloper);

        return isVisible;
    }

    isScaniaListsVisible(): boolean {
        while (this.user.UserId == null)
            this.wait()
        let isVisible: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsDeveloper);

        return isVisible;
    }

    isScaniaApprover(): boolean {
        while (this.user.UserId == null)
            this.wait()
        let isVisible: boolean =
            (this.user.IsScaniaApprover
                || this.user.IsPackagingAdmin)
            || this.user.IsDeveloper;

        return isVisible;
    }

    isPackitAdmin(): boolean {
        while (this.user.UserId == null)
            this.wait()
        let isVisible: boolean = (
            this.user.IsPackagingAdmin)
            || this.user.IsDeveloper;

        return isVisible;
    }

    isSupplierWithNoSuppNo(): boolean {
        return this.user.IsPartSupplierUser
            && (this.user.SupplierNumber == null || this.user.SupplierNumber == "0");
    }

    canActivate(instructionId: number): boolean {
        if (this.user.IsPackagingAdmin || this.user.IsDeveloper || this.user.IsPackagingEngineer)
            return true;

        let foundRejectedItem = this.sentToMultiBySupplierList.find(x => x.InstructionId == instructionId).SupplierResponses.findIndex(x => x.ToStatusId == StatusEnum.RejectedBySupplier) != -1;

        return (foundRejectedItem && this.isPackitAdmin());
    }

    canActivateMultiple(): boolean {
        if (this.user.IsPackagingAdmin || this.user.IsDeveloper || this.user.IsPackagingEngineer)
            return true;

        let foundRejectedItems = false;
        this.sentToMultiBySupplierList.forEach(x => x.SupplierResponses.forEach(function (item) {
            if (item.ToStatusId == StatusEnum.RejectedBySupplier) {
                foundRejectedItems = true;
            }
        }));

        return (foundRejectedItems && this.isPackitAdmin());
    }


    //LongTerm
    //Get basic info about instruction
    //Perform Conflict-checks
    //Activate
    loadInstruction(intructionId: number) {
        this.packInstrService.getInstruction(intructionId)
            .subscribe(returnObject => this.loadInstructionResponse(returnObject));
    }

    loadInstructionResponse(returnObject: IReturnObject) {
        this.instruction = null;
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.loadInstructionResponse', returnObject.ErrorType);
        else
            this.setLoadedValues(returnObject);
    }

    setLoadedValues(returnObject: IReturnObject) {
        this.instruction = <PackageInstructionItem>returnObject.DataList[0];
        this.instruction.Parts = <PackageIntructionPart[]>returnObject.DataList[0].Parts;
        this.instruction.SendPreliminaryToMona = true;
        this.loadPruList();
        this.performPreSaveChecks();
    }

    performPreSaveChecks() {
        if (this.isAtLeasOnePart()) {
            this.packInstrService.isFirstPIWithPnl(JSON.parse(JSON.stringify(this.instruction)))
                .subscribe(responseObj => this.isFirstPIWithPnlResponse(responseObj));
        }
        else
            this.chooseActivationType();
    }

    isFirstPIWithPnlResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg,
                'DashboardComponent.isFirstPIWithPnlResponse',
                returnObject.ErrorType);
        }
        else {
            if (returnObject.DataList[0] == true) {
                this.addPnlAndStsToPkgInstr();
            }
            this.packInstrService.checkConflict(JSON.parse(JSON.stringify(this.instruction)))
                .subscribe(responseObj => this.checkConflictResponse(responseObj));
        }
    }

    checkConflictResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.checkConflict', returnObject.ErrorType);
        }
        else {
            this.activeConflictItemId = 0;
            this.conflictResponseObj = returnObject.DataList;

            //exclude NoConflict items
            this.conflictResponseObj = this.conflictResponseObj.filter(x => x.ConflictType != ConflictTypeEnum.NoConflict);

            if (this.conflictResponseObj.length == 0) {
                this.chooseActivationType();
            }
            else {
                this.currentConflictDlg = this.modalService.open(this.conflictPruDlg, {
                    size: 'sm',
                    backdrop: 'static',
                    keyboard: false
                });
                // this.chooseActivationType();
            }
        }
    }


    chooseActivationType() {
        if (this.activateFromList == "approved") {
            this.updateFlowStatus(this.approvedBySupplierList[this.itemNoToActivate].Id,
                this.approvedBySupplierList[this.itemNoToActivate].SupplierId,
                StatusEnum.Active,
                this.approvedBySupplierList,
                this.approvedBySupplierList[this.itemNoToActivate].PackagingType);
        }
        else if (this.activateFromList == "rejected") {
            this.updateFlowStatus(this.rejectedBySupplierList[this.itemNoToActivate].Id,
                this.rejectedBySupplierList[this.itemNoToActivate].SupplierId,
                StatusEnum.Active,
                this.rejectedBySupplierList,this.rejectedBySupplierList[this.itemNoToActivate].PackagingType);
        }
        else if (this.activateFromList == "senttomultiple") {
            this.updateSentToMultipleFlowStatus(this.sentToMultiBySupplierList[this.itemNoToActivate].InstructionId,
                StatusEnum.Active, this.sentToMultiBySupplierList[this.itemNoToActivate].PackagingType);
        }
    }

    performActionConflictDlg() {
        if (this.conflictResponseObj[this.activeConflictItemId].ConflictType == ConflictTypeEnum.LastUnitConflict) {
            this.packInstrService.scrapPkgInstr(this.conflictResponseObj[this.activeConflictItemId].PkgInstrId)
                .subscribe(x => this.scrapPkgInstrResponse(x));
        }
        else if (this.conflictResponseObj[this.activeConflictItemId].ConflictType == ConflictTypeEnum.NormalUnitConflict) {
            this.packInstrService.UncheckPruRelation(this.conflictResponseObj[this.activeConflictItemId])
                .subscribe(x => this.uncheckPruRelationResponse(x));
        }
        else if (this.conflictResponseObj[this.activeConflictItemId].ConflictType == ConflictTypeEnum.DifferentLevelAssetsConflict) {
            this.cancelActionConflictDlg();
        }

    }

    cancelActionConflictDlg() {
        this.currentConflictDlg.close();
        this.hideLoadingAnimations();
    }

    updateConflictPopup() {
        this.activeConflictItemId++;
        if (this.activeConflictItemId == this.conflictResponseObj.length) {
            //to continue to show all conflict in a row to user.
            this.performPreSaveChecks();
            this.currentConflictDlg.close()
        }
    }

    uncheckPruRelationResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.uncheckPruRelation', returnObject.ErrorType);
        }
        else {
            this.updateConflictPopup();
            this.info("Conflicting unit relation is successfully unchecked.");
        }
    }

    scrapPkgInstrResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.scrapPkgInstr', returnObject.ErrorType);
        }
        else {
            this.updateConflictPopup();
            this.info("Conflicting Packaging Instruction is successfully scrapped.");
        }
    }

    addPnlAndStsToPkgInstr() {
        if (!this.isTherePnlInPkgInstr())
            this.instruction.PruRelations.push(new PkgInstrPruRelationBE(PnL, this.instruction.Id, this.instruction.Parts[0].PartId));
        this.instruction.SendPreliminaryToMona = true;
    }

    isTherePnlInPkgInstr(): boolean {
        return this.instruction.PruRelations.findIndex(x => x.PruId == PnL) == -1
            ? false
            : true;
    }

    getPruName(pruid: number): string {
        return this.pruList.find(x => x.Id == pruid).Description;
    }

    isAtLeasOnePart(): boolean {
        return this.instruction.Parts != null && this.instruction.Parts.length > 0;
    }

    info(message: string): void {
        this.errHandler.emitError(message, '', ErrorTypeEnum.Info);
    }

    loadPruList() {
        this.packInstrService.getPruList()
            .subscribe(returnObject => this.loadPruListResponse(returnObject));

    }

    loadPruListResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.loadPruList', returnObject.ErrorType);
        else {
            this.pruList = returnObject.DataList;
            PnL = this.pruList.find(x => x.Description == "P&L").Id;
            CW2 = this.pruList.find(x => x.Description == "SL").Id;
        }
    }

    getSupplierBySupplierNo(supplierNo: string, extendedSupplierNo: string) {
        if (supplierNo != null) {
            if (supplierNo !== 'undefined') {
                if (supplierNo != "0") {
                    this.errHandler.emitErrorObject(null);
                    this.supplierService.getSupplierBySupplierNo(supplierNo, extendedSupplierNo)
                        .subscribe(returnObject => this.getSupplierBySupplierNoResponse(returnObject));
                }
            }
        }
    }

    getSupplierBySupplierNoResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'SupplierContactComponent.getSupplierBySupplierNoResponse', returnObject.ErrorType);
        else {
            if(returnObject.RecordCount == 0)
               this.info("Supplier configuration is missing.");
            else if(returnObject.RecordCount > 0)
            this.selectedSupplierId = returnObject.DataList[0].Id;
        }
    }

}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/dashboard/dashboard.component.ts